// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__hTSxT","activeLink":"Navigation_activeLink__5-iuc Navigation_link__hTSxT"};